import en from "./default.json"
import de from "./default_de.json"
import es from "./default_es.json"
import fi from "./default_fi.json"
import fr from "./default_fr.json"
import it from "./default_it.json"
import nl from "./default_nl.json"
import no from "./default_no.json"
import pl from "./default_pl.json"
import pt from "./default_pt.json"
import ru from "./default_ru.json"
import tr from "./default_tr.json"

export { de,en, es, fi, fr, it, nl, no, pl, pt, ru, tr }
